import { BadgeProps } from '.';
import { borderColor as bColor, borderWidth as bWidth, borderStyle } from '../../Utilities/utils/Theming';
import { IBadgeColors, TSize } from './types';

const paddingSize: any = {
	default: 'var(--epods--badge-default-paddingX)',
	compact: 'var(--epods--badge-compact-paddingX)',
	large: 'var(--epods--badge-large-paddingX)',
};

const themes: any = {
	green: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-green)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-green-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-green)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-green-disabled)',
		textColor: 'var(--epods--color-text-badge-green)',
		disabledTextColor: 'var(--epods--color-text-badge-green-disabled)',
	},

	red: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-red)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-red-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-red)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-red-disabled)',
		textColor: 'var(--epods--color-text-badge-red)',
		disabledTextColor: 'var(--epods--color-text-badge-red-disabled)',
	},

	blue: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-blue)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-blue-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-blue)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-blue-disabled)',
		textColor: 'var(--epods--color-text-badge-blue)',
		disabledTextColor: 'var(--epods--color-text-badge-blue-disabled)',
	},

	grey: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-grey)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-grey-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-grey)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-grey-disabled)',
		textColor: 'var(--epods--color-text-badge-grey)',
		disabledTextColor: 'var(--epods--color-text-badge-grey-disabled)',
	},

	default: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-grey)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-grey-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-grey)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-grey-disabled)',
		textColor: 'var(--epods--color-text-badge-grey)',
		disabledTextColor: 'var(--epods--color-text-badge-grey-disabled)',
	},

	lightindigo: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-lightindigo)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-lightindigo-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-lightindigo)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-lightindigo-disabled)',
		textColor: 'var(--epods--color-text-badge-lightindigo)',
		disabledTextColor: 'var(--epods--color-text-badge-lightindigo-disabled)',
	},

	lightpurple: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-lightpurple)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-lightpurple-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-lightpurple)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-lightpurple-disabled)',
		textColor: 'var(--epods--color-text-badge-lightpurple)',
		disabledTextColor: 'var(--epods--color-text-badge-lightpurple-disabled)',
	},

	lightblue: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-lightblue)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-lightblue-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-lightblue)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-lightblue-disabled)',
		textColor: 'var(--epods--color-text-badge-lightblue)',
		disabledTextColor: 'var(--epods--color-text-badge-lightblue-disabled)',
	},

	lightneutral: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-lightneutral)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-lightneutral-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-lightneutral)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-lightneutral-disabled)',
		textColor: 'var(--epods--color-text-badge-lightneutral)',
		disabledTextColor: 'var(--epods--color-text-badge-lightneutral-disabled)',
	},

	lightamber: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-lightamber)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-lightamber-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-lightamber)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-lightamber-disabled)',
		textColor: 'var(--epods--color-text-badge-lightamber)',
		disabledTextColor: 'var(--epods--color-text-badge-lightamber-disabled)',
	},

	outline: {
		borderStyle: 'solid',
		borderColor: 'var(--epods--color-border-badge-outline)',
		borderWidth: 'var(--epods--border-width)',
		borderRadius: 'var(--epods--border-radius)',
		disabledBorderColor: 'var(--epods--color-border-badge-outline-disabled)',
		backgroundColor: 'var(--epods--color-bg-badge-outline)',
		disabledBackgroundColor: 'var(--epods--color-bg-badge-outline-disabled)',
		textColor: 'var(--epods--color-text-badge-outline)',
		disabledTextColor: 'var(--epods--color-text-badge-outline-disabled)',
	},
};

const themeSelector = (_disabled: boolean, theme: string, size: TSize, rest: BadgeProps) => {
	const _borderColor = _disabled
		? { ...bColor(rest.disabledBorderColor || themes[theme].disabledBorderColor) }
		: { ...bColor(rest.borderColor || themes[theme].borderColor) };

	const _color = _disabled
		? { color: rest.disabledTextColor || themes[theme].disabledTextColor }
		: { color: rest.textColor || themes[theme].textColor };

	const _background = _disabled
		? { backgroundColor: rest.disabledBackgroundColor || themes[theme].disabledBackgroundColor }
		: { backgroundColor: rest.backgroundColor || themes[theme].backgroundColor };

	const _borderRadius = {
		square: '0px',
		rounded: '4px',
		'rounded-sm': '2px',
		'rounded-lg': '6px',
	};

	const _fontSize = size === 'default' ? 'default' : 'compact';
	// No mandatory at theme level
	const _fontSizeFinal = rest.fontSize
		? 'var(--epods--badge-' + rest.fontSize + '-font-size)'
		: themes[theme].fontSize
		? 'var(--epods--badge-' + themes[theme].fontSize + '-font-size)'
		: 'var(--epods--badge-' + _fontSize + '-font-size)';
	// No mandatory at theme level
	const _fontWeightFinal = rest.fontWeight
		? 'var(--epods--font-base-' + rest.fontWeight + ')'
		: themes[theme].fontWeight
		? 'var(--epods--font-base-' + themes[theme].fontWeight + ')'
		: 'var(--epods--font-base-semibold)';

	return {
		borderStyle: rest.borderStyle || themes[theme].borderStyle,
		borderRadius: rest.borderRadius ? _borderRadius[rest.borderRadius] : themes[theme].borderRadius,
		...bWidth(rest.borderWidth || themes[theme].borderWidth),
		..._borderColor,
		..._color,
		..._background,
		fontSize: _fontSizeFinal,
		fontFamily: _fontWeightFinal,
	};
};

export const BadgeStyles = (
	theme: keyof IBadgeColors | 'default' = 'default',
	disabled = false,
	size: TSize,
	rest: BadgeProps,
) => {
	return {
		...themeSelector(disabled, theme, size, rest),
		textAlign: 'center' as const,
		display: 'inline-flex',
		alignItems: 'center',
		paddingRight: paddingSize[size],
		paddingLeft: paddingSize[size],
		height: size === 'default' ? 'var(--epods--badge-default-height)' : 'var(--epods--badge-compact-height)',
		lineHeight:
			size === 'default' ? 'var(--epods--badge-default-line-height)' : 'var(--epods--badge-compact-line-height)',
		minWidth:
			size === 'default' ? 'var(--epods--badge-default-min-width)' : 'var(--epods--badge-compact-min-width)',
	};
};

/** Notification Badge */

const dotRadius = {
	// NOTE: Sizes are [10,8,6,4] +2px for border
	large: '12px',
	default: '10px',
	compact: '8px',
	mini: '6px',
};

export const NotificationBadgeStyles = (size: TSize) => {
	return {
		backgroundColor: 'var(--epods--color-bg-badge-blue)',
		border: '1px solid var(--epods--color-bg)',
		borderRadius: '50%',
		display: 'block',
		height: dotRadius[size],
		width: dotRadius[size],
	};
};
